export const COOKIE_TEXT = {
    bar: {
        label: 'Cookie consent',
        intro: 'We use cookies to enhance your browsing experience and analyse our traffic. By clicking "Accept", you consent to our use of analytics cookies. For more information, please read our',
        accept: 'Accept',
        reject: 'Reject',
        manage: 'Manage',
    },
    dialog: {
        label: 'Cookie settings',
        enableAll: 'Enable All',
        save: 'Save Settings',
        close: 'Close',
        sections: [
            {
                id: 'overview',
                title: 'Privacy Overview',
                paragraphs: [
                    'This website uses cookies so that we can provide you with the best user experience possible. Cookie information is stored in your browser and performs functions such as recognising you when you return to our website and helping our team to understand which sections of the website you find most interesting and useful.',
                ],
            },
            {
                id: 'necessary',
                title: 'Strictly Necessary Cookies',
                switch: 'locked',
                paragraphs: [
                    'Strictly Necessary Cookies should be enabled at all times so that we can save your preferences for cookie settings.',
                ],
            },
            {
                id: 'analytics',
                title: '3rd Party Cookies',
                switch: 'analytics',
                paragraphs: [
                    'This website uses Google Analytics to collect anonymous information such as the number of visitors to the site, and the most popular pages.',
                    'Keeping this cookie enabled helps us to improve our website.',
                ],
            },
        ],
    },
    settingsButton: 'Change cookie settings',
    switch: {
        enabled: 'Enabled',
        disabled: 'Disabled',
    },
    policyLink: 'Cookie Policy',
};

export const DEFAULT_LOGO_ALT = 'ECAL';
export const DEFAULT_COOKIE_POLICY_URL = 'https://ecal.com/cookie-policy/';
